// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Czechia */
const CZ = /^(?:7060\d{5}|(?:60[1-8]|7(?:0[2-5]|19|[2379]\d))\d{6})$/;

export default CZ;
